import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@material-ui/core";
import AntDataGrid from "../../shared/components/AntDataGrid";
import {epochToDate} from "../../shared/functions/toDateTime";
import {keys, orderBy} from 'lodash'
import {useMemo} from "react";

const THEAD = [
    {dataIndex: 'name', title: "Vendor"},
    {dataIndex: 'price', title: "Price"},
    {
        dataIndex: 'updatedAt', title: "Updated At",
        render: date => epochToDate(date)
    },
]

const format = (selected) => {
    let list = []

    keys(selected).forEach(id => {
        const name = selected[id]?.Name;
        const priceChange = selected[id]?.Prices || [];
        priceChange.forEach(one => {
            list.push({
                id:list?.length+1,
                name,
                price: Number(one?.Price),
                updatedAt: one?.UpdateAt
            })

        })
    })

    return orderBy(list,'price','asc')
}

export default function ItemPriceReport({selected, open, onClose}) {

    const list = useMemo(() => format(selected), [selected])


    return (
        <Dialog open={open} onClose={onClose}>

            <DialogTitle>
                Price Report
            </DialogTitle>

            <DialogContent>
                <AntDataGrid
                    data={list}
                    columns={THEAD}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Fermer
                </Button>

            </DialogActions>
        </Dialog>
    )
}